import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.gray300};
  padding: 8px 0;
  margin-top: 8px;
`

interface IProps {
  isOpen: boolean
}

export const Title = styled.div<IProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ isOpen }) => (isOpen ? `${theme.colors.black}` : `${theme.colors.gray600}`)};
  font-weight: ${({ isOpen }) => (isOpen ? '600' : '400')};
  transition: font-weight 0.1s;

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.medium};
  }
`

export const IconContainer = styled.div<IProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 1px;
  border: 1.5px solid
    ${({ isOpen }) => (isOpen ? `${theme.colors.black}` : `${theme.colors.gray600}`)};
  border-radius: 50%;

  svg {
    path {
      fill: ${({ isOpen }) => (isOpen ? `${theme.colors.black}` : `${theme.colors.gray600}`)};
    }
  }
`

export const Content = styled.div<IProps>`
  display: block;
  max-height: ${({ isOpen }) => (isOpen ? '200px' : '0')};
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
  font-size: 12px;
  color: ${theme.colors.gray600};
  margin-top: 8px;

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`
